"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const appendDeduplicationSuffix = (key, keyNum) => `${key}__${keyNum}`;
const maybeFixDuplicateKey = (key, keyNum) => keyNum > 0 ? appendDeduplicationSuffix(key, keyNum) : key;
const ALREADY_DEDUPED_KEY_REGEXP = /^(.*)__(\d+)$/;
const getAlreadyDedupedKeyNums = (list) => list.reduce((keyNums, { key }) => {
    const m = key.match(ALREADY_DEDUPED_KEY_REGEXP);
    if (m) {
        const baseKey = m[1];
        const parsedKeyNum = parseInt(m[2], 10);
        const keyNum = Math.max(keyNums[baseKey] || 0, parsedKeyNum) + 1;
        keyNums[baseKey] = keyNum;
    }
    return keyNums;
}, {});
const getNextKeyNum = ({ alreadyDedupedKeyNums, key, nextKeyNums, }) => {
    const nextKeyNum = nextKeyNums[key] || 0;
    if (nextKeyNum && alreadyDedupedKeyNums[key]) {
        return Math.max(alreadyDedupedKeyNums[key], nextKeyNum);
    }
    return nextKeyNum;
};
function fixDuplicateKeys(list) {
    const alreadyDedupedKeyNums = getAlreadyDedupedKeyNums(list);
    const nextKeyNums = {};
    return list.map(({ key, value }) => {
        const nextKeyNum = getNextKeyNum({
            alreadyDedupedKeyNums,
            key,
            nextKeyNums,
        });
        nextKeyNums[key] = nextKeyNum + 1;
        return {
            key: maybeFixDuplicateKey(key, nextKeyNum),
            value,
        };
    });
}
exports.default = fixDuplicateKeys;
